import {
  ACTIVATE_CLOSED_CAPTIONS,
  CANCEL_REQUESTED_DVR,
  CLOSE_CHANNEL_BANNER,
  CLOSE_CHANNEL_GUIDE,
  CLOSE_SIDEBAR,
  DISMISS_ERROR,
  FETCH_CHANNELS_FAILURE,
  FETCH_CHANNELS_REQUEST,
  FETCH_CHANNELS_SUCCESS,
  FETCH_CHANNEL_FAILURE,
  FETCH_CHANNEL_PACKAGES_FAILURE,
  FETCH_CHANNEL_PACKAGES_REQUEST,
  FETCH_CHANNEL_PACKAGES_SUCCESS,
  FETCH_CHANNEL_REQUEST,
  FETCH_CHANNEL_SUCCESS,
  FETCH_CHANNEL_WARNING,
  FETCH_FEATURED_CHANNELS_FAILURE,
  FETCH_FEATURED_CHANNELS_REQUEST,
  FETCH_FEATURED_CHANNELS_SUCCESS,
  FETCH_PACKAGE_DETAILS_SUCCESS,
  FETCH_PREMIUM_DETAILS_SUCCESS,
  FETCH_PROGRAMS_FAILURE,
  FETCH_PROGRAMS_REQUEST,
  FETCH_PROGRAMS_SUCCESS,
  FETCH_PROGRAM_DVRS_SUCCESS,
  FETCH_RADIOS_REQUEST,
  FETCH_RADIOS_SUCCESS,
  FETCH_RADIO_FAILURE,
  FETCH_RADIO_REQUEST,
  FETCH_RADIO_SUCCESS,
  FILTER_BY_CATEGORY,
  FOCUS_CHANNEL,
  FOCUS_FEATURED_POSITION,
  FOCUS_PROGRAM,
  HIDE_CHANNEL_CHANGER,
  HIDE_CLOSED_CAPTIONS,
  INACTIVATE_CLOSED_CAPTIONS,
  OPEN_CHANNEL_BANNER,
  OPEN_CHANNEL_GUIDE,
  OPEN_CHANNEL_LIST,
  OPEN_FAVORITE_LIST,
  REQUEST_DVR,
  RESET_FILTER_BY_CATEGORY,
  SCHEDULE_DVR_SUCCESS,
  SELECT_CHANNEL,
  SHOW_CHANNEL_CHANGER,
  SHOW_CLOSED_CAPTIONS,
  SOFT_SELECT_CHANNEL,
  UPDATE_PLAYING_STATUS,
  UPDATE_SOCIAL_BROADCASTERS,
  FETCH_PREVIEW_URL_SUCCESS,
} from 'actions/channels'
import { PAY_NOW_SUCCESS } from 'actions/checkout'
import { REMOVE_DVR_SUCCESS } from 'actions/dvr'
import { LOGIN_SUCCESS } from 'actions/login'
import { LOGOUT_SUCCESS } from 'actions/logout'
import {
  VIEW_MODE_CHANNEL_BANNER,
  VIEW_MODE_CHANNEL_GUIDE,
  VIEW_MODE_CHANNEL_LIST,
  VIEW_MODE_CHANNEL_VIEW,
  VIEW_MODE_FAVORITE_LIST,
  TOGGLE_MUTED,
  FULLSCREEN_MODE,
} from 'constants/channels'
import { FETCH_SETTINGS_SUCCESS } from '../actions/app'

const getChannelIds = (state, category) => {
  if (typeof category === 'undefined') {
    category = state.category
  }
  if (category === '' || category === '_all_') {
    return state.allIds
  } else if (typeof state.byCategory[category] !== 'undefined') {
    return state.byCategory[category]
  } else {
    return []
  }
}

const getSelectedId = (state, requestedChannelId) => {
  const channelIds = getChannelIds(state)
  let selectedId = requestedChannelId
  if (selectedId === -1 || !channelIds.includes(selectedId)) {
    selectedId =
      state.selectedId > 0 && channelIds.includes(state.selectedId)
        ? state.selectedId
        : channelIds[0]
  }
  return selectedId
}

const getFocusedId = state => {
  let focusedId = state.selectedId
  if (
    state.category !== '' &&
    typeof state.byCategory[state.category] !== 'undefined' &&
    state.byCategory[state.category].length > 0
  ) {
    const selectedChannelIdx = state.byCategory[state.category].findIndex(
      channelId => channelId === state.selectedId
    )
    if (selectedChannelIdx === -1) {
      focusedId = state.byCategory[state.category][0]
    }
  }
  return focusedId
}

const getChannelGuideIndexes = (state, category, focusedId) => {
  const channelIds = getChannelIds(state, category)
  let currentIndex = channelIds.findIndex(id => id === focusedId)
  if (currentIndex === -1) {
    currentIndex = 0
  }

  let fromIndex = state.focusedProgram.fromIndex
  if (fromIndex === -1 || fromIndex > channelIds.length - 1) {
    fromIndex = currentIndex
  }
  if (channelIds.length > 5 && fromIndex > channelIds.length - 5) {
    fromIndex = channelIds.length - 5
  }
  let toIndex = fromIndex + 5

  if (currentIndex < fromIndex) {
    fromIndex = currentIndex
    toIndex = fromIndex + 5
  } else if (currentIndex >= toIndex) {
    toIndex = currentIndex + 1
    fromIndex = toIndex > 4 ? toIndex - 5 : 0
  }

  if (toIndex > channelIds.length) {
    toIndex = channelIds.length
  }

  return {
    fromIndex,
    toIndex,
  }
}

const getFocusedProgram = (state, category, channelId, position) => {
  const { fromIndex, toIndex } = getChannelGuideIndexes(state, category, channelId)
  return {
    channelId,
    position,
    fromIndex,
    toIndex,
  }
}

const INITIAL_STATE = {
  byId: {},
  byNo: {},
  allIds: [],
  category: '_all_',
  byCategory: {},
  isReady: false,
  isFetching: false,
  error: false,
  errorMessage: '',
  selectedId: -1,
  focusedId: -1,
  programsIsFetching: false,
  programsTo: -1,
  programs: {},
  channelGuideInterval: {
    from: -1,
    duration: 72,
  },
  focusedProgram: {
    channelId: -1,
    position: -1,
    fromIndex: -1,
    toIndex: -1,
  },
  selectedChannelBanner: {
    channelId: -1,
    position: -1,
  },
  viewMode: VIEW_MODE_CHANNEL_GUIDE,
  channelChangerNumber: '',
  channelChangerOpen: false,
  channelChangerError: false,
  hasClosedCaptions: false,
  closedCaptionsShown: false,
  programDvrsLastRetrieved: -1,
  requestedDvr: null,
  socialBroadcastersAvailable: false,
  socialBroadcastersRequested: false,
  isRadioListReady: true,
  packages: {},
  packagesById: {},
  featuredReady: false,
  featuredFetching: false,
  featuredHasError: false,
  featuredErrorMessage: '',
  featuredIds: [],
  featuredPosition: 0,
  videoMuted: false,
  fullScreen: false,
}

const channelsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
    case DISMISS_ERROR:
      return {
        ...INITIAL_STATE,
        socialBroadcastersAvailable: state.socialBroadcastersAvailable,
      }

    case FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        socialBroadcastersAvailable: action.payload.settings.social_tab === 'yes',
      }

    case FETCH_CHANNELS_REQUEST:
      return {
        ...state,
        isReady: false,
        isFetching: true,
        error: false,
        errorMessage: '',
      }
    case FETCH_CHANNELS_SUCCESS:
      const allIds = Object.keys(action.payload.byNo)
        .sort((a, b) => (parseInt(a) > parseInt(b) ? 1 : -1))
        .map(key => action.payload.byNo[key])
      const newByCategory = {}
      for (let channelId in action.payload.byId) {
        const category = action.payload.byId[channelId].category
        if (category) {
          if (typeof newByCategory[category] === 'undefined') {
            newByCategory[category] = []
          }
          newByCategory[category].push(parseInt(channelId, 10))
        }
      }
      const orderedNewByCategory = {}
      Object.keys(newByCategory)
        .sort()
        .forEach(key => {
          orderedNewByCategory[key] = allIds.filter(id => newByCategory[key].includes(id))
        })
      return {
        ...state,
        isReady: true,
        isFetching: false,
        byId: action.payload.byId,
        byNo: action.payload.byNo,
        allIds: allIds,
        byCategory: orderedNewByCategory,
        category: '_all_',
        focusedProgram: {
          ...INITIAL_STATE.focusedProgram,
        },
        selectedChannelBanner: {
          ...INITIAL_STATE.selectedChannelBanner,
        },
        lastUpdated: action.payload.receivedAt,
      }
    case FETCH_CHANNELS_FAILURE:
      return {
        ...state,
        isReady: true,
        isFetching: false,
        error: true,
        errorMessage: action.payload.message,
      }

    case FETCH_CHANNEL_REQUEST:
    case FETCH_RADIO_REQUEST:
      const current = state.byId[action.payload.id]
      let newCurrent
      if (!current) {
        newCurrent = {
          id: action.payload.id,
        }
      } else if (current.type === 'radio') {
        newCurrent = {
          id: action.payload.id,
          type: 'radio',
          genre: current.genre,
          desc: current.desc,
          isLive: !!current.isLive,
          no: current.no,
          name: current.name,
          img: current.img,
          dvr: false,
        }
      } else {
        newCurrent = {
          id: action.payload.id,
          type: current.type,
          isLive: !!current.isLive,
          no: current.no,
          name: current.name,
          img: current.img,
          dvr: !!current.dvr,
          category: current.category,
          isPremium: current.isPremium,
          hasAccess: current.hasAccess,
        }
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: newCurrent,
        },
      }

    case FETCH_CHANNEL_SUCCESS:
    case FETCH_RADIO_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...action.payload,
            lastUpdated: Date.now(),
          },
        },
      }
    case FETCH_CHANNEL_WARNING:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.meta.id]: {
            ...state.byId[action.meta.id],
            lastUpdated: Date.now(),
          },
        },
      }
    case FETCH_CHANNEL_FAILURE:
    case FETCH_RADIO_FAILURE:
      const newChannelDetails = {
        ...state.byId[action.meta.id],
        lastUpdated: Date.now(),
        error: true,
        errorMessage: action.payload.message,
        needsSubscription:
          action.meta.needsSubscription !== undefined
            ? action.meta.needsSubscription
            : false,
        subscriptionAvailablePackages:
          action.meta.subscriptionAvailablePackages !== undefined
            ? action.meta.subscriptionAvailablePackages
            : -1,
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.meta.id]: newChannelDetails,
        },
      }

    case SELECT_CHANNEL:
      const selectedId = getSelectedId(state, action.payload.id)
      if (!selectedId) {
        return state
      }

      let channelGuideInterval = {
        ...state.channelGuideInterval,
      }
      let newViewMode = state.viewMode
      if (action.payload.viewMode === VIEW_MODE_CHANNEL_VIEW) {
        newViewMode =
          selectedId !== state.selectedId || state.byId[selectedId].type === 'radio'
            ? VIEW_MODE_CHANNEL_BANNER
            : VIEW_MODE_CHANNEL_VIEW
      } else if (action.payload.viewMode === VIEW_MODE_CHANNEL_BANNER) {
        newViewMode = VIEW_MODE_CHANNEL_BANNER
      } else if (action.payload.viewMode === VIEW_MODE_CHANNEL_LIST) {
        newViewMode = VIEW_MODE_CHANNEL_LIST
      } else if (action.payload.viewMode === VIEW_MODE_CHANNEL_GUIDE) {
        newViewMode = VIEW_MODE_CHANNEL_GUIDE
        channelGuideInterval = {
          from: action.payload.from,
          duration: action.payload.duration,
        }
      }

      return {
        ...state,
        selectedId: selectedId,
        focusedId: selectedId,
        focusedProgram: getFocusedProgram(state, undefined, selectedId, -1),
        selectedChannelBanner: {
          channelId: selectedId,
          position: -1,
        },
        viewMode: newViewMode,
        hasClosedCaptions:
          state.selectedId === selectedId ? state.hasClosedCaptions : false,
        closedCaptionsShown: action.payload.closedCaptions,
        byId: {
          ...state.byId,
          [selectedId]: {
            ...state.byId[selectedId],
            isPlaying: false,
          },
        },
        channelGuideInterval,
      }
    case SOFT_SELECT_CHANNEL:
      let softSelectedId = action.payload.id
      if (typeof state.byId[softSelectedId] === 'undefined') {
        return state
      }
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_BANNER,
        selectedChannelBanner: {
          channelId: softSelectedId,
          position: -1,
        },
      }
    case FOCUS_CHANNEL:
      return {
        ...state,
        focusedId: action.payload.id,
      }
    case OPEN_CHANNEL_LIST:
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_LIST,
      }
    case OPEN_FAVORITE_LIST:
      return {
        ...state,
        viewMode: VIEW_MODE_FAVORITE_LIST,
      }
    case CLOSE_SIDEBAR:
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_VIEW,
        focusedId: getFocusedId(state),
      }
    case FETCH_PROGRAMS_REQUEST:
      return {
        ...state,
        programsIsFetching: true,
      }
    case FETCH_PROGRAMS_SUCCESS:
      const newPrograms = {}
      for (let channelId in state.byId) {
        const programs = action.payload.programs[channelId]
          ? action.payload.programs[channelId]
          : []
        newPrograms[channelId] = programs
      }
      return {
        ...state,
        programs: newPrograms,
        programsIsFetching: false,
        programsTo: action.payload.to,
      }
    case FETCH_PROGRAMS_FAILURE:
      return {
        ...state,
        programsIsFetching: false,
      }

    case OPEN_CHANNEL_GUIDE:
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_GUIDE,
        channelGuideInterval: {
          from: action.payload.from,
          duration: action.payload.duration,
        },
      }
    case CLOSE_CHANNEL_GUIDE:
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_VIEW,
        channelGuideInterval: {
          from: -1,
          duration: 72,
        },
        focusedProgram: getFocusedProgram(state, undefined, getFocusedId(state), -1),
      }
    case FOCUS_PROGRAM:
      return {
        ...state,
        focusedProgram: getFocusedProgram(
          state,
          undefined,
          action.payload.channelId,
          action.payload.position
        ),
      }

    case OPEN_CHANNEL_BANNER:
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_BANNER,
      }
    case CLOSE_CHANNEL_BANNER:
      return {
        ...state,
        viewMode: VIEW_MODE_CHANNEL_VIEW,
        selectedChannelBanner: {
          channelId: -1,
          position: -1,
        },
      }

    case SHOW_CHANNEL_CHANGER:
      return {
        ...state,
        channelChangerNumber: action.payload.channelNumber,
        channelChangerOpen: true,
        channelChangerError: action.payload.isError,
      }

    case HIDE_CHANNEL_CHANGER:
      return {
        ...state,
        channelChangerNumber: '',
        channelChangerOpen: false,
        channelChangerError: false,
      }

    case ACTIVATE_CLOSED_CAPTIONS:
      return {
        ...state,
        hasClosedCaptions: true,
      }
    case INACTIVATE_CLOSED_CAPTIONS:
      return {
        ...state,
        hasClosedCaptions: false,
      }
    case SHOW_CLOSED_CAPTIONS:
      return {
        ...state,
        closedCaptionsShown: true,
      }
    case HIDE_CLOSED_CAPTIONS:
      return {
        ...state,
        closedCaptionsShown: false,
      }

    case FETCH_PROGRAM_DVRS_SUCCESS:
      const newDvrPrograms = {}
      for (let channelId in state.byId) {
        if (state.programs[channelId]) {
          newDvrPrograms[channelId] = state.programs[channelId].map(program => {
            if (typeof action.payload[program.id] !== 'undefined') {
              return {
                ...program,
                dvr: true,
                dvrStatus: action.payload[program.id],
              }
            } else {
              return {
                ...program,
                dvr: false,
              }
            }
          })
        }
      }
      return {
        ...state,
        programs: newDvrPrograms,
        programDvrsLastRetrieved: Date.now(),
      }

    case REMOVE_DVR_SUCCESS:
      return {
        ...state,
        programDvrsLastRetrieved: -1,
      }

    case REQUEST_DVR:
      return {
        ...state,
        requestedDvr: action.payload,
      }

    case CANCEL_REQUESTED_DVR:
      return {
        ...state,
        requestedDvr: null,
      }

    case SCHEDULE_DVR_SUCCESS:
      if (!state.programs[action.payload.channelId]) {
        return state
      }
      return {
        ...state,
        programs: {
          ...state.programs,
          [action.payload.channelId]: state.programs[action.payload.channelId].map(
            program => {
              if (program.id === action.payload.programId) {
                program.dvr = true
                program.dvrStatus = 'pending'
              }
              return program
            }
          ),
        },
      }

    case RESET_FILTER_BY_CATEGORY:
      return {
        ...state,
        category: '_all_',
        focusedProgram: getFocusedProgram(state, '_all_', getFocusedId(state), -1),
      }

    case FILTER_BY_CATEGORY:
      let focusedId = state.selectedId
      if (state.byCategory[action.payload].length > 0) {
        const selectedChannelIdx = state.byCategory[action.payload].findIndex(
          channelId => channelId === state.selectedId
        )
        if (selectedChannelIdx === -1) {
          focusedId = state.byCategory[action.payload][0]
        }
      }
      return {
        ...state,
        category: action.payload,
        focusedId: focusedId,
        focusedProgram: getFocusedProgram(state, action.payload, focusedId, -1),
        selectedChannelBanner: {
          channelId: focusedId,
          position: -1,
        },
      }

    case FETCH_PREMIUM_DETAILS_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.channelId]: {
            ...state.byId[action.payload.channelId],
            premium: action.payload.details,
          },
        },
      }

    case FETCH_CHANNEL_PACKAGES_REQUEST:
      return {
        ...state,
        packages: {
          ...state.packages,
          [action.payload.id]: {
            ready: false,
            loading: true,
            packages: [],
          },
        },
      }

    case FETCH_CHANNEL_PACKAGES_SUCCESS:
      return {
        ...state,
        packages: {
          ...state.packages,
          [action.payload.channelId]: {
            ready: true,
            loading: false,
            packages: action.payload.packages,
          },
        },
      }

    case FETCH_CHANNEL_PACKAGES_FAILURE:
      return {
        ...state,
        packages: {
          ...state.packages,
          [action.payload.meta.id]: {
            ready: true,
            loading: false,
            error: true,
            packages: [],
          },
        },
      }

    case FETCH_PACKAGE_DETAILS_SUCCESS:
      return {
        ...state,
        packagesById: {
          ...state.packagesById,
          [action.payload.pkg.id]: action.payload.pkg,
        },
      }

    case UPDATE_PLAYING_STATUS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [state.selectedId]: {
            ...state.byId[state.selectedId],
            isPlaying: true,
          },
        },
      }

    case UPDATE_SOCIAL_BROADCASTERS:
      return {
        ...state,
        programsTo: -1,
        socialBroadcastersRequested:
          state.socialBroadcastersAvailable && action.payload.socialBroadcasters,
        selectedId: -1,
        category: '_all_',
        featuredReady: false,
        featuredFetching: false,
        featuredHasError: false,
        featuredErrorMessage: '',
        featuredIds: [],
      }

    case FETCH_RADIOS_REQUEST:
      return {
        ...state,
        isRadioListReady: false,
      }
    case FETCH_RADIOS_SUCCESS:
      const newById = {
        ...state.byId,
        ...action.payload.byId,
      }
      const newByNo = {
        ...state.byNo,
        ...action.payload.byNo,
      }
      return {
        ...state,
        isRadioListReady: true,
        byId: newById,
        byNo: newByNo,
        allIds: Object.keys(newByNo)
          .sort((a, b) => (parseInt(a) > parseInt(b) ? 1 : -1))
          .map(key => newByNo[key]),
      }

    case FETCH_FEATURED_CHANNELS_REQUEST:
      return {
        ...state,
        featuredReady: false,
        featuredFetching: true,
        featuredHasError: false,
        featuredErrorMessage: '',
      }
    case FETCH_FEATURED_CHANNELS_SUCCESS:
      const newFeaturedIds = action.payload.filter(
        id => typeof state.byId[id] !== 'undefined'
      )
      return {
        ...state,
        featuredReady: true,
        featuredFetching: false,
        featuredHasError: false,
        featuredErrorMessage: '',
        featuredIds: newFeaturedIds,
        featuredPosition: 0,
      }
    case FETCH_FEATURED_CHANNELS_FAILURE:
      return {
        ...state,
        featuredReady: true,
        featuredFetching: false,
        featuredHasError: true,
        featuredErrorMessage: action.payload.message,
      }
    case FOCUS_FEATURED_POSITION:
      return {
        ...state,
        featuredPosition: action.payload.position,
      }

    case FETCH_PREVIEW_URL_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.channelId]: {
            ...state.byId[action.payload.channelId],
            previewUrl: action.payload.previewUrl,
            previewUrlRetrieved: Date.now(),
          },
        },
      }
    case TOGGLE_MUTED:
      return {
        ...state,
        videoMuted: action.muted,
      }
    case FULLSCREEN_MODE: {
      return {
        ...state,
        fullScreen: action.screen,
      }
    }

    default:
      return state
  }
}

export default channelsReducer
